import { Star, Quotes } from "@phosphor-icons/react";

const Testimonials = ({ items, loading }) => {
  if (loading) {
    return (
      <section id="testimonials" className="py-24 sm:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="animate-pulse space-y-8">
            <div className="h-8 bg-slate-200 w-48" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="h-48 bg-slate-100" />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      id="testimonials"
      className="py-24 sm:py-32 bg-white"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#0B2F6B]">
            Testimonials
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-[#1A1A2E]">
            What Our Clients Say
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what medical professionals
            across the country have to say about our services.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="testimonial-card bg-slate-50 border border-slate-200 p-8 relative"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote Icon */}
              <Quotes
                className="absolute top-6 right-6 w-12 h-12 text-[#0B2F6B]/10"
                weight="fill"
              />

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-5 h-5 ${
                      i < testimonial.rating
                        ? "text-amber-500"
                        : "text-slate-200"
                    }`}
                    weight="fill"
                  />
                ))}
              </div>

              {/* Content */}
              <p className="text-slate-700 leading-relaxed text-lg relative z-10">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="mt-6 pt-6 border-t border-slate-200">
                <div className="font-semibold text-[#1A1A2E]">
                  {testimonial.name}
                </div>
                <div className="text-sm text-slate-600">
                  {testimonial.role} at {testimonial.company}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
